<template>
  <div class="pacing-check">
    <div class="pacing-container">
      <help-tooltip v-if="enabledWarning" type="warning">
        {{ enabledWarning.message }}
      </help-tooltip>
      <el-select
        v-close-on-zoom
        :value="state.check.isCurrent"
        :disabled="readonly"
        class="current-select"
        @input="value => updateIsCurrent(value)"
      >
        <el-option :value="false" :label="'Has pacing been administered'" />
        <el-option :value="true" :label="'Is pacing being administered'" />
      </el-select>
    </div>
    <div class="current-container">
      <el-input
        v-integer-only
        type="number"
        class="range-input current-min-input"
        :value="state.check.current.min"
        placeholder="any"
        @input="v => updateCurrent('min', parseInt(v))" 
      >
        <template slot="prepend">
          with current between          
          <help-tooltip v-if="currentWarning" type="warning">
            {{ currentWarning.message }}
          </help-tooltip>
        </template>
      </el-input>
      <el-input
        v-integer-only
        type="number"
        class="range-input current-max-input"
        :value="state.check.current.max"
        placeholder="any"
        @input="v => updateCurrent('max', parseInt(v))" 
      >
        <template slot="prepend">and</template>
      </el-input>
    </div>
    <div class="rate-container">
      <el-input
        type="number"
        class="range-input rate-min-input"
        :value="state.check.rate.min"
        placeholder="any"
        @input="v => updateRate('min', v)"
      >
        <template slot="prepend">
          with rate between          
          <help-tooltip v-if="rateWarning" type="warning">
            {{ rateWarning.message }}
          </help-tooltip>
        </template>
      </el-input>
      <el-input
        v-integer-only type="number"
        class="range-input rate-max-input"
        :value="state.check.rate.max"
        placeholder="any"
        @input="v => updateRate('max', v)"
      >
        <template slot="prepend">and</template>
      </el-input>
    </div>
  </div>
</template>
 
<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'pacing-check',
  components: {
    HelpTooltip,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        check: {
          current: {
            min: 0,
            max: 0,
          },
          rate: {
            min: 0,
            max: 0,
          },
          isCurrent: false,
        },
      },
    };
  },
  computed: {
    pacingTreatment() {
      const { caseConf } = this.emitter;
      return caseConf._treatments.find(t => t.id === 'PACING');
    },
    currentBounds() {
      return get(
        this.pacingTreatment,
        'options.componentOptions.CURRENT.allowedRange',
        [0, 0],
      );
    },
    rateBounds() {
      return get(
        this.pacingTreatment,
        'options.componentOptions.RATE.allowedRange',
        [0, 0],
      );
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      return uniqBy(
        get(
          this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
          `caseLogicDescription.${this.control.parent.id}`,
          [],
        ).filter(
          warning => warning.metadata && warning.metadata.scope === 'control' && warning.metadata.checkId === this.ikey,
        ),
        'message',
      );
    },
    enabledWarning() {
      return this.warnings.find(warning => warning.metadata.componentId === 'PACING');
    },
    rateWarning() {
      return this.warnings.find(warning => warning.metadata.componentId === 'RATE');
    },
    currentWarning() {
      return this.warnings.find(warning => warning.metadata.componentId === 'CURRENT');
    },
  },
  mounted() {
    this.state.check = { ...this.state.check, ...this.getData(this.ikey) };
    // Populate with defaults when the check is created
    if (!this.getData(this.ikey)) {
      this.state.check.current = {
        min: this.currentBounds[0],
        max: this.currentBounds[1],
      };
      this.state.check.rate = {
        min: this.rateBounds[0],
        max: this.rateBounds[1],
      };
      this.state.isCurrent = false;
    }
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updateCurrent(key, value) {
      this.state.check.current[key] = parseFloat(value);
      this.update();
    },
    updateRate(key, value) {
      this.state.check.rate[key] = parseFloat(value);
      this.update();
    },
    updateIsCurrent(value) {
      this.state.check.isCurrent = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PACING',
        id: 'TRANSCUTANEOUS',
        operator: 'EQUAL',
        value: true,
        ...this.state.check,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>
 
<style scoped>
.pacing-check {
  width: 100%;
  display: flex;
  flex-direction: column;
  color: black;
}

.current-select {
  flex: 1;
}

.range-input {
  width: auto;
}

.pacing-container,
.current-container,
.rate-container {
  display: flex;
  align-items: center;
}

.help-tooltip {
  margin-left: 5px;
}

.el-input {
  flex: 1;
}

.help-tooltip {
  margin: 0 4px;
}
</style>
